import React, { useCallback, useEffect, useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { scrollToCompra } from '../utils/scroll';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/qkz9tj7ohMmHbiFvRUPk7F/7DB2F62F-8091-4795-AE47-BD7896CEAE61.webp',
  alt: '¿Por qué los peces son los animales más eficientes?',
  caption: '¿Por qué los peces son los animales más eficientes?'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/m58UVSDTYGavVvKJHdSSxB/913D9A76-536D-4810-B651-B3A55F1A9C5B.webp',
  alt: 'Alimentos Funcionales y Nutrición de Precisión',
  caption: 'Alimentos Funcionales y Nutrición de Precisión'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7dpvJ1XRq52nTfRiAfWYVx/AD45A1F2-4D9A-4857-B834-D13D5FDB4D97.webp',
  alt: 'Mes 1 — Introducción a la Acuicultura (Semanas 1-4)',
  caption: 'Planificación Semanal — Mes 1 (Semanas 1-4)'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vaDfxS4Uakw5cYuS9npR3a/E4093FD9-FE72-4BDF-83E6-8972AE2DF573.webp',
  alt: 'Examen Tomo 4 — Alimentación y Nutrición Acuícola',
  caption: 'Examen Tomo 4 — Alimentación y Nutrición'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cwT8QmLpYgJdpoyEcNk3Vu/F1269C75-EA3D-4B35-B538-F762A6580019.webp',
  alt: 'Las 10 Innovaciones que Transforman la Acuicultura',
  caption: 'Las 10 Innovaciones que Transforman la Acuicultura'
}];
export function SystemPreview() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const next = useCallback(() => setIndex(i => (i + 1) % slides.length), []);
  const prev = useCallback(() => setIndex(i => (i - 1 + slides.length) % slides.length), []);
  useEffect(() => {
    if (paused) return;
    const id = setInterval(next, 4500);
    return () => clearInterval(id);
  }, [paused, next]);
  return <section className="py-7 px-4 bg-brand-cream border-y-2 border-brand-line" data-id="element-227">
      <div className="max-w-4xl mx-auto" data-id="element-228">
        <div className="text-center max-w-3xl mx-auto mb-5" data-id="element-229">
          <p className="text-brand-green font-display font-bold uppercase text-xs md:text-sm tracking-widest mb-2" data-id="element-230">
            Un sistema diseñado por técnicos de campo para docentes argentinos
          </p>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy uppercase leading-tight mb-2" data-id="element-231">
            Mirá el sistema <span className="green-highlight" data-id="element-232">por dentro</span>
          </h2>
          <p className="text-sm md:text-base text-brand-mute font-medium leading-snug" data-id="element-233">
            Así es el material que vas a usar el lunes.{' '}
            <span className="text-brand-ink font-bold" data-id="element-234">
              Lo que ves es lo que recibís.
            </span>
          </p>
        </div>

        <div className="relative bg-white rounded-xl border-2 border-brand-navy overflow-hidden shadow-[5px_5px_0_#1A365D]" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-id="element-235">
          <div className="relative aspect-[4/5] sm:aspect-[3/2] md:aspect-[16/10] overflow-hidden bg-white" data-id="element-236">
            {slides.map((slide, i) => <button key={i} onClick={scrollToCompra} aria-hidden={index !== i} aria-label={slide.alt} tabIndex={index === i ? 0 : -1} className={`absolute inset-0 w-full h-full flex items-center justify-center transition-opacity duration-500 ease-in-out ${index === i ? 'opacity-100 z-10' : 'opacity-0 z-0 pointer-events-none'}`} data-id="element-237">
                <img src={slide.src} alt={slide.alt} className="max-w-full max-h-full object-contain" loading={i === 0 ? 'eager' : 'lazy'} data-id="element-238" />
              </button>)}
          </div>

          <div className="bg-brand-navy text-white py-2.5 px-4 text-center border-t-2 border-brand-orange" data-id="element-239">
            <p className="text-xs md:text-sm font-display font-bold uppercase tracking-wide truncate" data-id="element-240">
              <span className="text-brand-orange mr-1.5" data-id="element-241">●</span>
              {slides[index].caption}
            </p>
          </div>

          <button onClick={prev} aria-label="Anterior" className="absolute left-2 md:left-3 top-1/2 -translate-y-1/2 z-20 bg-white/95 hover:bg-brand-orange hover:text-white text-brand-navy w-9 h-9 md:w-11 md:h-11 rounded-full border-2 border-brand-navy flex items-center justify-center transition-colors shadow-md" data-id="element-242">
            <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" strokeWidth={3} data-id="element-243" />
          </button>
          <button onClick={next} aria-label="Siguiente" className="absolute right-2 md:right-3 top-1/2 -translate-y-1/2 z-20 bg-white/95 hover:bg-brand-orange hover:text-white text-brand-navy w-9 h-9 md:w-11 md:h-11 rounded-full border-2 border-brand-navy flex items-center justify-center transition-colors shadow-md" data-id="element-244">
            <ChevronRight className="w-5 h-5 md:w-6 md:h-6" strokeWidth={3} data-id="element-245" />
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-4" data-id="element-246">
          {slides.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Ir al slide ${i + 1}`} className={`h-2.5 rounded-full transition-all ${index === i ? 'w-8 bg-brand-orange' : 'w-2.5 bg-brand-navy/30 hover:bg-brand-navy/60'}`} data-id="element-247" />)}
        </div>
      </div>
    </section>;
}